import React, {useState, useEffect, useRef, useMemo} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createRequestData, downloadDocument, getDocumentBlob, requestDeleteApiCall} from '../../Utility/apiHelper';
import {Box,IconButton,MenuItem,Typography,Tooltip, Button} from '@mui/material';
import { StyledFlexStart, StyledLeadContainer, StyledSubHeader } from '../../Components/Styled';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import BiztantuFooterButton from '../../Components/FotterButton';
import { privateRoutesPath } from '../../Routes';
import { ACTIVE_STATUS, handleValidateCodevalue, languageCode, MAX_TOTAL_SIZE, searchEntity, TEMPLATE_STATUS, TEMPLATE_TYPE, templateChannel, templateParams } from '../../Utility/constant';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import { useSnackbar } from 'notistack';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { requestEmptySpecificTemplate, requestGetSpecificTemplate, requestUpdateTemplate } from '../../Store/Template/action';
import BiztantuLoader from '../../Components/Loader';
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import { getFileTypeIcon } from '../../Utility/fileIconUtils';
import LeadAccordion from '../../Components/LeadAccordion';
import { removeExcessiveTags } from '../../Utility/textHelper';
import useNavigation from '../../Utility/hooks/useNavigation';
import './template.css';
const BiztantuCreateEditTemplate = (props) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const campaignid = props.match.params.id;
    const { enqueueSnackbar } = useSnackbar();
    
    const [newAttachments, setNewAttachments] = useState([]); 
    const [deleteAttachmentIds, setDeleteAttachmentIds] = useState([]); 
    const [templateBody, setTemplateBody] = useState("");
    const dispatch = useDispatch();
    const specificTemplate  = useSelector(state=> state?.template?.specificTemplate);
    const lookupData = useSelector(state => state?.lookup?.lookupData);
    const getLookupCodes = (name) => lookupData?.find((item) => item?.name === name)?.codes?.filter(item => item?.status === ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);

    const { navigateTo,goBackTo } = useNavigation();
    const templateStatus = getLookupCodes(TEMPLATE_STATUS);
    const templateType = getLookupCodes(TEMPLATE_TYPE);

    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const [notificationDeatils, setNotificationDetails] = useState({
        status : "TEMPLATE_STATUS_ACTIVE",
        existingAttachments : [],
        channel : "TEMPLATE_CHANNEL_EMAIL"
    });
    const [initialNotificationDetails, setInitialNotificationDetails] = useState([]);
    const [requiredError, setRequiredError] = useState({
        name: false,
        type: false,
        status: false,
        channel: false,
        templateBody: false,
        templateAttachment: false,
        subject: false
    });
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const currentClientId = currentUser?.client?.id;
  const fileInputRef = useRef(null);
    useEffect(() => {
        if(campaignid) {
            handlegetSpecifictemplate(campaignid);
        }
        return () =>{
             dispatch(requestEmptySpecificTemplate())
        }
    },[campaignid]);

    useEffect(() => {
    if(campaignid && specificTemplate) {
        const updatedTemplate = {
            ...specificTemplate,
            existingAttachments: specificTemplate?.attachments || []
        };
        setNotificationDetails(updatedTemplate);
        setTemplateBody(specificTemplate?.templateBody);
        setInitialNotificationDetails({
            ...specificTemplate,
            templateBody: specificTemplate?.templateBody
        });
    }
}, [specificTemplate]);


    const handlegetSpecifictemplate  = async(id) => {
        dispatch(requestShowLoader())
        const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/get-template/${id}`;
        await dispatch(requestGetSpecificTemplate(url));
        dispatch(requestHideLoader())
    }

    const modules = {
        toolbar: [
          [{ 'header': [1, 2, false] }],
          ['bold', 'italic',],
          [ {'list': 'bullet'}],
          ['link'],

        ],
      }
    
      const formats = [
        'header',
        'bold', 'italic',
        'list', 'bullet',
        'link'
      ]

    const validateMandatoryFields = () => {
    const isValid = isWhatsappChannel ? 
        templateBody && notificationDeatils?.name && notificationDeatils?.status && 
        notificationDeatils?.channel && notificationDeatils?.type && notificationDeatils?.language
        :
        templateBody && notificationDeatils?.name && notificationDeatils?.status && 
        notificationDeatils?.channel && notificationDeatils?.type && notificationDeatils?.subject
    if (!isValid) {
        setRequiredError({
            type: true, name: true, status: true, channel: true,language : true,
            templateBody: true, templateAttachment: true, subject: true
        });
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS"), {variant:"error"});
    }
    return isValid;
};

const isWhatsappChannel = useMemo(() => {
  return notificationDeatils?.channel === "TEMPLATE_CHANNEL_WHATSAPP";
}, [notificationDeatils?.channel]);

const WHATSAPP_PLACEHOLDER = handleValidateCodevalue(internationalise,"TEMP_BODY_WAPP_PLACEHOLDER");

useEffect(() => {
  if(!campaignid){
  if (notificationDeatils?.channel === "TEMPLATE_CHANNEL_WHATSAPP") {
    setTemplateBody(WHATSAPP_PLACEHOLDER);
  }
  else
    setTemplateBody("");
  }
}, [notificationDeatils?.channel]);

   const handleCreateCampaign = async() => {
    dispatch(requestShowLoader());
    
    if(!validateMandatoryFields()) {
        dispatch(requestHideLoader());
        return;
    }
        const { totalSize } = calculateAttachmentSizes();
    if (totalSize > MAX_TOTAL_SIZE) {
        enqueueSnackbar(handleValidateCodevalue(internationalise, "ATTACHMENT_SIZE_EXCEEDED") || "Total attachment size exceeds 25MB limit", {variant: "error"});
        dispatch(requestHideLoader());
        return;
    }
    
    const {existingAttachments,...restParam} = notificationDeatils;
    const notificationPayload = {
        ...restParam,
        clientId : currentClientId,
        templateBody: removeExcessiveTags(templateBody)
    };

    if(newAttachments.length > 0) {
        const formdata = new FormData();
        formdata.append('notification', JSON.stringify(notificationPayload));
        newAttachments.forEach(file => {
            formdata.append('files', file);
        });
        const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/create-template-with-attachment`;
        const responsedata = await createRequestData(formdata, url, true);

        if(responsedata?.status === 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"TEMP_CREATED_WITH_ATTACHMENT"), {variant: "success"});
            navigateTo(`${privateRoutesPath?.EDIT_TEMPLATE}/${responsedata?.data?.id}`,{},searchEntity?.template);
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
            setNewAttachments([]);
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responsedata?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), {variant: "error"});
        }
    } else {
        const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/create-template-without-attachment`;
        const responsedata = await createRequestData(notificationPayload, url);
        if(responsedata?.status === 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"TEMP_CREATED_WO_ATTACHMENT"), {variant: "success"});
            
            navigateTo(`${privateRoutesPath?.EDIT_TEMPLATE}/${responsedata?.data?.id}`,{},searchEntity?.template);
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responsedata?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), {variant: "error"});
        }
    }
    
    dispatch(requestHideLoader());
}


    const handleupdatecampaign = async (value) => {
    dispatch(requestShowLoader());
    
    if(!validateMandatoryFields()) {
        dispatch(requestHideLoader());
        return;
    }
    
    const { totalSize } = calculateAttachmentSizes();
    
    if (totalSize > MAX_TOTAL_SIZE) {
        enqueueSnackbar(handleValidateCodevalue(internationalise, "ATTACHMENT_SIZE_EXCEEDED") || "Total attachment size exceeds 25MB limit", {variant: "error"});
        dispatch(requestHideLoader());
        return;
    }

    const hasAttachmentChanges = newAttachments.length > 0 || deleteAttachmentIds.length > 0;
    const {existingAttachments, ...restParams} = notificationDeatils;
    
    if((JSON.stringify(restParams) == JSON.stringify(initialNotificationDetails)) &&
        (initialNotificationDetails?.templateBody === removeExcessiveTags(templateBody)) &&
        !hasAttachmentChanges
    ){
        if(value){
            handleCustomBackbutton();
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"), {variant : 'info'});
        }
        dispatch(requestHideLoader());
        return;
    }
    
    const notificationPayload = {
        ...restParams,
        clientId : currentClientId,
        templateBody: removeExcessiveTags(templateBody),
    };

    const formdata = new FormData();
    formdata.append('notification', JSON.stringify(notificationPayload));
    newAttachments.forEach(file => {
        formdata.append('files', file);
    });
    
    const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/update-template/${campaignid}`;
    const response = await dispatch(requestUpdateTemplate(formdata, url, enqueueSnackbar, internationalise));  
    
    if (response?.status !== 'error' && response?.status < 400) {
        setNewAttachments([]);
        setDeleteAttachmentIds([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        
        await handlegetSpecifictemplate(campaignid);
        if(value){
            handleCustomBackbutton();
        }
    }
    
    dispatch(requestHideLoader());
}


    const handleCustomBackbutton = () => {
        // setNotificationDetails([]);
        // setInitialNotificationDetails([]);
        // setNewAttachments([]);
        // setDeleteAttachmentIds([]);
        // setTemplateBody(null);
        goBackTo(privateRoutesPath.BIZTANTU_TEMPLATE,searchEntity?.template);
    }

    const handleOnChange = (event) => {
        setNotificationDetails({
            ...notificationDeatils,
            [event.target.name]: event.target.value
        })
    }

    const handleSelectFile = (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
           const { totalSize: currentTotal } = calculateAttachmentSizes();
            const addingSize = files.reduce((sum, file) => sum + file.size, 0);
            const totalSize = currentTotal + addingSize;

            if (totalSize > MAX_TOTAL_SIZE) {
                enqueueSnackbar(handleValidateCodevalue(internationalise, "ATTACHMENT_SIZE_EXCEEDED") || "Total attachment size exceeds 25MB limit", {variant: "error"});
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
                return;
            }

            setNewAttachments(prev => [...prev, ...files]);
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    }

    const handleRemoveNewAttachment = (index) => {
        setNewAttachments(prev => prev.filter((_, i) => i !== index));
    }

const handleDeleteExistingAttachment = async (attachmentId) => {
  dispatch(requestShowLoader());

  try {
    const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/delete-attachment/${attachmentId}`;

    const response = requestDeleteApiCall(url)

    if (!response.status >=200 || response?.status < 300) {
      enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),{ variant: "error" });
      return;
    }
    const attachments = notificationDeatils?.existingAttachments.filter((att) => att.id !== attachmentId)
    setNotificationDetails(prev=>({
      ...prev,
      existingAttachments : attachments
    }))

    enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_DELETED_SUCCESSFULLY"),{ variant: "success" });
  } catch (error) {
    console.error("Error deleting attachment:", error);

    enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN") ,{ variant: "error" });
  } finally {
    dispatch(requestHideLoader());
  }
};

    const formatFileSize = (bytes) => {
        if (!bytes) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    const getTotalAttachmentSize = () => {
    const { totalSize } = calculateAttachmentSizes();
    return totalSize;
};
    const quillRef = useRef(null);

   const handleAddParam = (event) => {

    const value = event.target.value;

    const quill = quillRef.current?.getEditor();
    if (!quill) return;
    const range = quill.getSelection(true);
    const index = range ? range.index : quill.getLength();

    quill.insertText(index, value, "user");
    quill.setSelection(index + value.length);
    };

const handleDownloadDoc = async (documentId) => {
  await downloadDocument(documentId);
};
const calculateAttachmentSizes = () => {
    const existingSize = notificationDeatils?.existingAttachments
        ?.filter(att => !deleteAttachmentIds.includes(att.id))
        ?.reduce((sum, att) => sum + (att.file_size || 0), 0) || 0;
    const newSize = newAttachments.reduce((sum, file) => sum + file.size, 0);
    return { existingSize, newSize, totalSize: existingSize + newSize };
};

    return (
      <React.Fragment>
            <BiztantuLoader open={isLoadingProgress} isChildren={true}>
            <Box className='globalBox'>
                <LeadAccordion
                    label={`${handleValidateCodevalue(internationalise, 'TEMP_EDIT_TEMPLATE_DETAILS')} ${campaignid ? - campaignid : ""}`}
                    defaultOpen={true}
                >
              {campaignid &&
                <Box className = "mt-15 mb-10">
                  <Button className='edit-primary ' variant="outlined" onClick={()=>handleupdatecampaign(false)}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>
                  <Button className='edit-primary btn-space' variant="outlined" onClick={()=>handleupdatecampaign(true)}>{handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}</Button>
                </Box>
              }
                <StyledLeadContainer>
                <TextFiledWithLabel
                        name="name"
                        required
                        disabled = {notificationDeatils?.systemTemplateFlag === "COMMON_YES"}
                        value= {notificationDeatils?.name}
                        label={ handleValidateCodevalue(internationalise,'TEMP_EDIT_NAME')}
                        handleOnChange={handleOnChange}
                        error = {notificationDeatils?.name ? false : requiredError?.name}
                    />
                    <SelectBoxWithLabel
                        isStatic={true}
                        name="channel"
                        disabled={campaignid}
                        value= {notificationDeatils?.channel ?? ""}
                        label={ handleValidateCodevalue(internationalise,'TEMP_EDIT_CHANNEL')}
                        required
                        optionMenuItem={templateChannel}
                        handleOnChange={handleOnChange}
                        error = {notificationDeatils?.channel ? false : requiredError?.channel}
                    
                    />
                    
                    <SelectBoxWithLabel
                        isStatic={false}
                        ownerdropdown={false}
                        name="type"
                        required
                        value= {notificationDeatils?.type ?? ""}
                        label={ handleValidateCodevalue(internationalise,'TEMP_EDIT_TYPE')}
                        optionMenuItem={templateType}
                        handleOnChange={handleOnChange}
                        error = {notificationDeatils?.type ? false : requiredError?.type}
                    
                    />
                    
                    <SelectBoxWithLabel
                        isStatic={false}
                        ownerdropdown={false}
                        name="status"
                        disabled= {campaignid ? false : true}
                        value= {notificationDeatils?.status ?? ""}
                        label= {handleValidateCodevalue(internationalise,'TEMP_EDIT_STATUS')}
                        required
                        optionMenuItem={templateStatus}
                        handleOnChange={handleOnChange}
                        error = {notificationDeatils?.status ? false : requiredError?.status}
                    
                    />
                </StyledLeadContainer>
                <StyledLeadContainer>
                  {isWhatsappChannel ? 
                        <SelectBoxWithLabel
                            variant='standard'
                            name = "language"
                            required
                            error = {notificationDeatils?.language ? false : requiredError?.language}
                            value={notificationDeatils?.language || ''}
                            label = {handleValidateCodevalue(internationalise,'COMMON_LANG_CODE')} 
                            optionMenuItem={languageCode}
                            handleOnChange={handleOnChange}
                        /> 
                        :
                    <TextFiledWithLabel
                        name="subject"
                        value= {notificationDeatils?.subject}
                        className="template-subject-field"
                        required
                        disabled={isWhatsappChannel}
                        label= {handleValidateCodevalue(internationalise,'TEMP_EDIT_SUBJECT')}
                        handleOnChange={handleOnChange}
                        error = {notificationDeatils?.subject ? false : requiredError?.subject}
                    />
                  }
                    {campaignid &&
                    <TextFiledWithLabel
                    disabled = {true}
                    label= {handleValidateCodevalue(internationalise,'TEMP_EDIT_EDITABLE')}
                    value={handleValidateCodevalue(internationalise,notificationDeatils?.systemTemplateFlag)}
                    />
                    }
                 </StyledLeadContainer>
              
            <StyledFlexStart className="template-body-toolbar">
                <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'TEMP_EDIT_BODY')}
                </StyledSubHeader>

                  {!isWhatsappChannel &&
                <TextFiledWithLabel
                    isStatic={true}
                    select
                    name="params"
                    value = {""}
                    label= {handleValidateCodevalue(internationalise,'TEMP_EDIT_ADD_PARAMS')}
                    handleOnChange={handleAddParam} 
                >
                   {templateParams?.map(option=>
                   <MenuItem key={option?.value} value={option?.value}>
                    {handleValidateCodevalue(internationalise,option?.label)} -- {option?.value}
                    </MenuItem>
                   )}
                    </TextFiledWithLabel>
                  }
            </StyledFlexStart>
            <StyledLeadContainer>
            <ReactQuill 
                    ref={quillRef}
                    theme="snow" 
                    value={templateBody} 
                    onChange={setTemplateBody} 
                    modules={modules}
                    formats={formats}
                    className={`template-editor${(!requiredError?.templateBody || templateBody) ? '' : ' template-editor-error'}`}
                />
                
            </StyledLeadContainer>
              </LeadAccordion>
            {/* Attachments Section - Always visible */}
            {!isWhatsappChannel &&
            <LeadAccordion
              label={`${handleValidateCodevalue(internationalise,"TEMP_EDIT_ATTACHMENTS")} 
              (${formatFileSize(getTotalAttachmentSize())} / 25 MB)`}
            >
                     
                <Box>   
                    <StyledSubHeader>
                        {handleValidateCodevalue(internationalise, 'TEMP_ADD_ATTACHMENTS')}
                    </StyledSubHeader>             

                
                    <input 
                        ref={fileInputRef} 
                        name="attachment" 
                        type="file" 
                        multiple
                        onChange={handleSelectFile}
                        className="template-attachment-input"
                    />
                {newAttachments?.length > 0 && (
                    <Box>
                        {newAttachments?.map((file, index) => (
                              <StyledFlexStart className="template-new-attachment">
                                <span className="template-attachment-name">{file.name}</span>
                                <span className="template-new-attachment-size">
                                    ({formatFileSize(file?.size)})
                                </span> 
                              <Tooltip title={handleValidateCodevalue(internationalise, 'COMMON_DELETE')}>
                                  <IconButton
                                    className="template-attachment-icon-button"
                                  onClick={()=>{handleRemoveNewAttachment(index)}}
                                  >
                                    <DeleteIcon className="template-delete-icon" />
                              </IconButton>
                                </Tooltip>
                                </StyledFlexStart>
                        ))}
                    </Box>
                )}
                </Box>
{campaignid && notificationDeatils?.existingAttachments?.length > 0 && (
  <Box mt={2}>
    <StyledSubHeader>
      {handleValidateCodevalue(internationalise, 'TEMP_EXISTING_ATTACHMENTS')}
    </StyledSubHeader>

    <Box
      className="template-attachments-grid"
    >
      {notificationDeatils?.existingAttachments?.map((attachment) => {
        
        return (
          <Box
            key={attachment.id}
            className="template-attachment-card"
          >
            {/* Hover actions */}
            <Box
              className="template-attachment-hover-actions"
            >
            <Tooltip title={handleValidateCodevalue(internationalise,"COMMON_DOWNLOAD")}>
                <IconButton
                  className="template-attachment-icon-button"
                onClick={()=>{handleDownloadDoc(attachment?.document_id)}}
                >
                  <DownloadIcon />
            </IconButton>
              </Tooltip>
              <Tooltip title={handleValidateCodevalue(internationalise,"COMMON_DELETE")}>
                <IconButton
                  className="template-attachment-icon-button"
                  onClick={() =>handleDeleteExistingAttachment(attachment.id)}
                >
                   <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Preview */}
            <Box
              className="template-attachment-preview"
            >
              <DocumentViewer
                documentId={attachment.document_id}
                fileName={attachment.file_name}
              />
            </Box>

            {/* File name */}
            <Typography
              variant="body2"
              className="template-existing-attachment-name"
            >
              {attachment.file_name}
            </Typography>

            {/* File size */}
            <Typography
              variant="caption"
              color="text.secondary"
              className="template-existing-attachment-size"
            >
              {formatFileSize(attachment.file_size)}
            </Typography>
          </Box>
        );
      })}
    </Box>
  </Box>
                )}

                {/* New Attachments (pending upload) */}

                {/* File Input - Always visible for adding more files */}

            </LeadAccordion>
            }
            
            </Box>
            <BiztantuFooterButton 
                isEdituser={!!campaignid}
                isiconRequired={false} 
                headerLabel={campaignid ? `${handleValidateCodevalue(internationalise, 'TEMP_EDIT_TITLE_EDIT')} - ${campaignid}` : "TEMP_EDIT_TITLE_CREATE"}
                actionlabel={campaignid ? "" : handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                isBackbtnreq={true}
                handleCustomBackbutton={handleCustomBackbutton}
                redirecturl=""
                handleActionButton={campaignid ? ()=>handleupdatecampaign(false) : handleCreateCampaign}
                backButtonLabel={handleValidateCodevalue(internationalise,'COMMON_BACK')}
            />
            </BiztantuLoader>
            
          </React.Fragment>
    )
}

const getFileTypeFromFilename = (filename) => {
  const ext = filename?.split('.').pop()?.toLowerCase();
  if (!ext) return "application/octet-stream";
  if (["jpg","jpeg","png","gif","webp","bmp"].includes(ext)) return "image/" + ext;
  if (ext === "pdf") return "application/pdf";
  return "application/octet-stream";
};

const DocumentViewer = ({ documentId, fileName }) => {
  const [url, setUrl] = useState(null);
  const [contentType, setContentType] = useState("");
  const [displayFilename, setDisplayFilename] = useState(fileName || "file");
  const dispatch = useDispatch();

  const extension = fileName?.split(".").pop();



  useEffect(() => {
    if (fileName) setDisplayFilename(fileName);
  }, [fileName]);

  useEffect(() => {
    let blobUrl;

    const load = async () => {
      dispatch(requestShowLoader());
      try {
        const response = await getDocumentBlob(documentId);
        const blob = response.data;
        const disposition = response.headers["content-disposition"];
        let resolvedFilename = fileName || "file";
        if (disposition && !fileName) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) resolvedFilename = match[1];
        }

        setDisplayFilename(resolvedFilename);

        let type = response.headers["content-type"];
        if (!type || type === "application/octet-stream") {
          type = getFileTypeFromFilename(resolvedFilename);
        }
        setContentType(type);

        blobUrl = URL.createObjectURL(new Blob([blob], { type }));
        setUrl(blobUrl);
      } catch (err) {
        console.error("Failed to load document", err);
      } finally {
        dispatch(requestHideLoader());
      }
    };

    load();

    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [documentId]);


  if (contentType.startsWith("image/")) {
    return (
      <img
        src={url}
        alt={displayFilename}
        className="template-document-image"
      />
    );
  }


  return (
      <span className="template-document-icon">
        {getFileTypeIcon(extension)}
      </span>
  );
};

export default BiztantuCreateEditTemplate